<template>
    <div class="occupation-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/occupation' }">查职业</el-breadcrumb-item>
            <el-breadcrumb-item>职业详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="occupation-detail-bg">
            <el-col :span="18">
                {{occupationInfor.job_name}}
            </el-col>
            <el-col :span="6">
                <el-button class="compare-view" v-if="fav_value < 0.00" v-click-with-auth-login @click="favDetail">
                    <img src="../../assets/images/fav_icon1.png" alt="设为心仪" class="fav-img1">
                    设为心仪
                </el-button>
                <el-button v-else class="compare-view-diff" @click="favDetail">
                    <el-rate
                        v-model="fav_value"
                        disabled
                        :max="1"
                        :show-score="false"
                        disabled-void-color="#ffcab3"
                        score-template="{fav_value}">
                    </el-rate>
                    {{ fav_value === 0.99 ? '心仪职业': '心仪详情' }}
                </el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="16" style="padding-right: 16px;width:67.5%">
                <div class="occupation-detail-common occupation-detail-infor">
                    <h3>职业介绍</h3>
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200"  v-if="!searchSchoolStatus1">
                        <rect x="0" y="10" width="1100" height="180" />
                    </ContentLoader>
                    <el-row v-else>
                        <div class="no-data-box" v-if="!occupationInfor.job_description">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>暂无数据</p>
                        </div>
                        <el-row v-else>
                            <div class="occupation-detail-js" :class="{'occupation-detail-js-more':showAllContent}" v-html="occupationInfor.job_description">
                            </div>
                            <div class="choice-box" @click="showAllhandler" v-if="!showAllContent">查看全部<i class="el-icon-arrow-down"></i></div>
                            <div class="choice-box" @click="showAllhandler" v-else>收起<i class="el-icon-arrow-up"></i></div>
                        </el-row>
                    </el-row>
                </div>
                <div class="occupation-detail-common">
                    <h3>就业岗位</h3>
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200"  v-if="!searchSchoolStatus1">
                        <rect x="0" y="10" width="1100" height="300" />
                    </ContentLoader>
                    <el-row v-else style="min-height: 300px;position:relative">
                        <div class="no-data-box" v-if="this.positionList.length == 0">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>暂无数据</p>
                        </div>
                        <el-row v-else>
                            <el-row type="flex" class="occupation-detail-job">
                                <el-col v-for="(item,index) in positionList" :key="index" :class="activeJobIndex == index ? 'occupation-detail-job-active':''" @click.native="changePositionHandler(index)">
                                    <div class="occupation-detail-job-title">{{item.position_name}}</div>
                                    <div class="occupation-detail-job-fee">{{item.min_salary + '-' + item.max_salary + '/月'}}</div>
                                    <div>热门地区:{{item.city}}</div>
                                </el-col>
                            </el-row>
                            <el-row class="occupation-detail-job-common">
                                <el-row>
                                    <h4>薪资情况</h4>
                                    <div class="occupation-detail-line"></div>
                                </el-row>
                                <el-row>
                                    <!-- <el-col :span="12" v-if="experienceXList.length!=0"> -->
                                    <el-col :span="12">
                                        <el-row class="occupation-detail-type">按趋势</el-row>
                                        <div ref="chart1" class="occupation-detail-chart1"></div>
                                        <div class="no-data-box" v-if="experienceXList.length==0 && searchSchoolStatus2">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无数据</p>
                                        </div>
                                    </el-col>
                                    <!-- <el-col :span="12" v-if="salaryList.length!=0"> -->
                                    <el-col :span="12">
                                        <el-row class="occupation-detail-type">按分布</el-row>
                                        <div ref="chart2" class="occupation-detail-chart1"></div>
                                        <div class="no-data-box" v-if="salaryList.length==0 && searchSchoolStatus2">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无数据</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-row>
                            <el-row class="occupation-detail-job-common">
                                <el-row>
                                    <h4>就业形势</h4>
                                    <div class="occupation-detail-line"></div>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-row class="occupation-detail-type">按学历</el-row>
                                        <div ref="chart3" class="occupation-detail-chart1"></div>
                                        <div class="no-data-box" v-if="eduList.length==0 && searchSchoolStatus2">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无数据</p>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row class="occupation-detail-type">按经验</el-row>
                                        <div ref="chart4" class="occupation-detail-chart1"></div>
                                        <div class="no-data-box" v-if="expList.length==0 && searchSchoolStatus2">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无数据</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-row>
                            <el-row type="flex" justify="space-between" class="occupation-detail-job-area">
                                <el-col class="occupation-detail-job-common occupation-detail-job-common-diff1" :span="12">
                                    <el-row>
                                        <h4>招聘需求量</h4>
                                        <div class="occupation-detail-line"></div>
                                    </el-row>
                                    <el-row class="occupation-detail-job-area-list">
                                        <el-row v-for="(item,index) in demandList" :key="index" type="flex">
                                            <el-col :span="2" :class="index==0?'area-top1':index==1?'area-top2':index==2?'area-top3':''">
                                                {{index + 1}}
                                            </el-col>
                                            <el-col :span="14">
                                                {{item.city}}
                                            </el-col>
                                            <el-col :span="8">
                                                {{item.count?item.count:''}}职位
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                    <div class="no-data-box" v-if="demandList.length==0 && searchSchoolStatus2">
                                        <img src="../../assets/images/null.png" alt="没有数据">
                                        <p>暂无数据</p>
                                    </div>
                                </el-col>
                                <el-col class="occupation-detail-job-common occupation-detail-job-common-diff2" :span="12">
                                    <el-row>
                                        <h4>收入排行-按地区</h4>
                                        <div class="occupation-detail-line"></div>
                                    </el-row>
                                    <el-row class="occupation-detail-job-area-list">
                                        <el-row v-for="(item,index) in citySalaryList" :key="index" type="flex">
                                            <el-col :span="2" :class="index==0?'area-top1':index==1?'area-top2':index==2?'area-top3':''">
                                                {{index + 1}}
                                            </el-col>
                                            <el-col :span="14">
                                                {{item.city}}
                                            </el-col>
                                            <el-col :span="8">
                                                {{item.salary?item.salary:''}}/月
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                    <div class="no-data-box" v-if="citySalaryList.length==0 && searchSchoolStatus2">
                                        <img src="../../assets/images/null.png" alt="没有数据">
                                        <p>暂无数据</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="8" style="width:32.5%;margin-top: 16px">
                <div class="occupation-detail-common">
                    <h3>选考学科建议</h3>
                    <div v-if="!searchSchoolStatus1">
                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="80" width="400" viewBox="0 0 1000 80" v-for="item in 6" :key="item">
                            <rect x="0" y="0" width="600" height="78" />
                            <rect x="0" y="79" width="600" height="1" />
                        </ContentLoader>
                    </div>
                    <el-row class="occupation-detail-subject" v-else>
                        <el-row v-for="(item,index) in specialList" :key="index">
                            <div @click="clickHandler(item.special_id)" style="cursor: pointer;">
                                <h4>{{item.special_name}}</h4>
                                <el-row>
                                    <el-col :span="10">国标代码:{{item.special_code?item.special_code:'-'}}</el-col>
                                    <el-col :span="6">学制:{{item.limit_year?item.limit_year:'-'}}</el-col>
                                    <el-col :span="8">男女比例:{{item.boy_rate?item.boy_rate + '/' + item.girl_rate:'-'}}</el-col>
                                </el-row>   
                            </div>
                        </el-row>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <FavDetail v-if="isFav" :favList="fav_data" :favInfo="fav_info" @update="updateFav"></FavDetail>
    </div>
</template>

<script>
import { getJobSurvey,getPositionDetail } from '@/api/occupation';
import { ContentLoader } from 'vue-content-loader';
import { mapState } from "vuex";
import echarts from 'echarts'
import { addFav, delFav } from '@/api/user'
import FavDetail from '@/components/FavDetail'
export default {
    components: {
        ContentLoader,
		FavDetail
    },
    data() {
        return {
            searchSchoolStatus1: false,
            showAllContent: false,
            occupationInfor: '',
            activeJobIndex: 0,
            positionList: [],
            specialList: [],
            citySalaryList:[],
            experienceXList:[],
            experienceYList:[],
            demandList:[],
            eduList:[],
            expList:[],
            industrySalaryList:[],
            salaryList:[],
            job_code: '',
            searchSchoolStatus2: false,
            fav_value: 0,
			fav_data: [],
			fav_info: {}
        };
    },
    computed: {
		...mapState({
			requestCount: state => state.user.requestCount,
            isFav: state => state.user.isFav
		}),
	},
    watch: {
        requestCount (newVal) {
            // this.searchSchoolStatus1 = false;
            if(newVal > 0) {
				this.searchSchoolStatus1 = false;
            } else {
                this.searchSchoolStatus1 = true;
            }
        }
    },
    mounted() {
        this.getJobSurveyHandler();
    },
    methods: {
        getJobSurveyHandler() {
            this.job_code = this.$route.query.job_code;
            getJobSurvey(this.job_code).then(res => {
                this.occupationInfor = res.data;
                this.fav_data = res.data.fav_data
				const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
				this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
				this.fav_value -= 0.01
                this.positionList = res.data.position_info.list;
                this.specialList = res.data.special_info.list;
                if(this.positionList.length > 0) {
                    this.getPositionDetailHandler();
                }
            })
        },
        showAllhandler() {
			this.showAllContent = !this.showAllContent;
		},
        getPositionDetailHandler() {
            getPositionDetail(this.positionList[this.activeJobIndex].id).then(res => {
                this.searchSchoolStatus2 = true
                this.citySalaryList = res.data.city_salary;
                this.demandList = res.data.demand;
                this.experienceYList = res.data.experience.map((item,index) => {
                    return item.salary;
                });
                this.experienceXList = res.data.experience.map((item,index) => {
                    return item.year;
                });
                this.eduList = res.data.edu.map((item,index) => {
                    return { name: `${item.edu}`, value: `${item.ratio}` };
                });
                this.expList = res.data.exp.map((item,index) => {
                    return { name: `${item.exp}`, value: `${item.ratio}` };
                });
                this.salaryList = res.data.salary.map((item,index) => {
                    if(item.min % 1000 == 0) {
                        if(item.max % 1000 == 0) {
                            item.name = (item.min/1000) + 'k-' + (item.max/1000) + 'k/月';
                        } else {
                            item.name = (item.min/1000) + 'k-' + (item.max/1000).toFixed(1) + 'k/月';
                        }
                    } else {
                        if(item.max % 1000 == 0) {
                            item.name = (item.min/1000).toFixed(1) + 'k-' + (item.max/1000) + 'k/月';
                        } else {
                            item.name = (item.min/1000).toFixed(1) + 'k-' + (item.max/1000).toFixed(1) + 'k/月';
                        }
                    }
                    item.value = item.ratio;
                    return item;
                });
                this.industrySalaryList = res.data.industry_salary;
                setTimeout(() => {
                    this.initChart1();
                    this.initChart2();
                    this.initChart3();
                    this.initChart4();
                }, 1300);
            })
        },
        initChart1() {
            const myChart = echarts.init(this.$refs.chart1);
            const option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#c4c7cc",
                            width: 1
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        color: "#999390",
                        fontSize: 12,
                        padding: [5, 0, 0, 0]
                    },
                    data: this.experienceXList
                },
                grid: {
                    left: '0',
                    right: '0',
                    top: '22',
                    width: '325',
                    height: '200',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 5,
                    // max : 15000,
                    // min : 0,
                    axisLine: {
                        show: false,
                    }, 
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        color: "#5e6166",
                        fontSize: 12,
                        align: "right",
                        padding: [0, 10, 0, 0]
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#f0f2f5',
                            width: 1
                        }
                    }
                },
                series: [
                    {
                        data: this.experienceYList,
                        type: 'line',
                        areaStyle: {},
                        label: {
                            show: true,
                            color: "#3474ff",
                            fontSize: 12
                        },
                        itemStyle: {
                            color: "#3474ff"
                        },
                        lineStyle: {
                            color: "#3474ff",
                            width: 1
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                    [
                                        {offset: 0.8, color: 'rgba(52,116,255,0.14)'},
                                        {offset: 1, color: 'rgba(52,116,255,0.00)'}
                                    ]
                                )
                            },
                        }
                    }
                ],
            };
            myChart.setOption(option);
        },
        initChart2() {
            const myChart = echarts.init(this.$refs.chart2);
            const option = {
                tooltip: {
                    trigger: 'item',
                },
                series: [{
                    type: 'pie',
                    radius: ['34%', '58%'],
                    data: this.salaryList,
                    label: {
                        color: "#66605e",
                        fontSize: 12,
                        formatter: '{b} {c}%',
                        padding: [0, 0, 0, 0],
                    },
                    labelLine: {
                        show: true,
                        length: 5,
                        length2: 5,
                        minTurnAngle:90,
                        maxSurfaceAngle: 0,
                    },
                    color:['#3272ff','#139b83','#FF8EB4','#fe9f0a','#FE5B0A','#32c7ff','#9E64FF'],
                }]
            };
            myChart.setOption(option);
        },
        initChart3() {
            const myChart = echarts.init(this.$refs.chart3);
            const option = {
                tooltip: {
                    trigger: 'item',
                },
                series: [{
                    type: 'pie',
                    radius: ['34%', '58%'],
                    data: this.eduList,
                    label: {
                        color: "#66605e",
                        fontSize: 12,
                        formatter: '{b} {c}%',
                        padding: [3, 4, 5, 6]
                    },
                    labelLine: {
                        show: true,
                        length: 5,
                        length2: 5,
                    },
                    color:['#fe9f0a','#3272ff','#32c7ff','#139b83'],
                }]
            };
            myChart.setOption(option);
        },
        initChart4() {
            const myChart = echarts.init(this.$refs.chart4);
            const option = {
                tooltip: {
                    trigger: 'item',
                },
                series: [{
                    type: 'pie',
                    radius: ['34%', '58%'],
                    data: this.expList,
                    label: {
                        color: "#66605e",
                        fontSize: 12,
                        formatter: '{b} {c}%',
                        padding: [3, 4, 5, 6]
                    },
                    labelLine: {
                        show: true,
                        length: 5,
                        length2: 5,
                    },
                    color:['#fe9f0a','#3272ff','#32c7ff','#139b83'],
                }]
            };
            myChart.setOption(option);
        },
        changePositionHandler(index) {
            this.activeJobIndex = index;
            this.citySalaryList = [],
            this.experienceXList = [],
            this.experienceYList = [],
            this.demandList = [],
            this.eduList = [],
            this.expList = [],
            this.industrySalaryList = [],
            this.salaryList = [],
            this.searchSchoolStatus2 = false,
            this.getPositionDetailHandler();
        },
        // 心仪详情
		favDetail() {
			if(this.fav_data.length <= 1) {
				const data = this.fav_data[0]
				const param = {
					stu_id: data.stu_id,
					fav_type: 3,
					data: this.job_code
				}
				if(data.fav === 0) {
					addFav(param).then(res => {
						data.fav = 1
                        this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				} else {
					delFav(param).then(res => {
						data.fav = 0
                        this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				}
				return
			}
			this.fav_info = {
				name: this.occupationInfor.job_name,
				id: this.job_code,
				fav_type: 3
			}
			this.$store.commit('user/SHOWISFAV', true)
		},
		// 心仪更新
		updateFav(data) {
			this.fav_data = [...data]
			const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
			this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
			this.fav_value -= 0.01
		},
        clickHandler(special_id) {
            if(!special_id) {
                this.$message({
                    message: '暂无相关专业信息',
                    type: 'warning'
                })
                return
            }
            this.$router.push({
                path: '/majorDetail',
                query: {
                    special_id: special_id
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.occupation-detail-box {
    @include gwidth;
}
.occupation-detail-bg {
    @include gwidth;
    height: 109px;
    background: url('../../assets/images/occupation-detail-bg.jpg') no-repeat;
    background-size: 100% 100%;
    margin-top: 24px;
    padding: 32px 40px;
    font-size: 32px;
    font-weight: 600;
    text-align: left;
    color: #ffffff;
    line-height: 45px;
}
.occupation-detail-js-more {
    max-height: 10000px;
}
.occupation-detail-common {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
    padding: 24px;
    margin-bottom: 16px;
    position: relative;
    h3 {
        font-size: 20px;
        font-weight: 600;
        color: #2c2e33;
        border-left: 3px solid $common-color;
        padding-left: 8px;
        margin-top: 0;
        margin-bottom: 20px;
    }
    p {
        font-size: 16px;
        color: #5e6166!important;
        margin-top: 5px;
        margin-bottom: 0;
        line-height: 24px;
    }
    p:not(:last-child) {
        margin-bottom: 12px;
    }
    .choice-box {
        font-size: 14px;
        margin-top: 10px;
        color: $common-color;
        cursor: pointer;
        float: right;
        i {
            margin-left: 5px;
        }
    }
}
.occupation-detail-infor {
    margin-top: 16px;
    h3 {
        margin-bottom: 4px;
    }
    .occupation-detail-js {
		font-size: 16px!important;
		color: #5e6166!important;
		text-align: left;
		line-height: 24px;
		max-height: 110px;
		overflow: hidden;
	}
	.occupation-detail-js p {
		font-size: 16px!important;
		color: #5e6166!important;
        margin: 0!important;
	}
	.occupation-detail-js-more {
		max-height: 10000px;
	}
}
.occupation-detail-job {
    flex-wrap: wrap;
    .el-col {
        width: 172px;
        height: 96px;
        background: #f5f7fa;
        border-radius: 5px;
        padding: 12px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #999390;
        line-height: 18px;
        margin-bottom: 16px;
        cursor: pointer;
    }
    .el-col:not(:nth-child(4n)) {
        margin-right: 15px;
    }
    .occupation-detail-job-title {
        font-size: 16px;
        font-weight: 600;
        color: #332e2c;
        line-height: 22px;
    }
    .occupation-detail-job-fee {
        margin: 8px 0 6px 0;
    }
    .occupation-detail-job-active {
        background: #fff3ee;
        border: 1px solid $common-color;
        .occupation-detail-job-title {
            color: $common-color;
        }
    }
}
.occupation-detail-job-common {
    .el-col-12,.el-col-24 {
        position: relative;
    }
    h4 {
        font-size: 18px;
        font-weight: 600;
        color: $common-color;
        line-height: 25px;
        margin: 0;
        margin-top: 8px;
    }
    .occupation-detail-line {
        border-top: 1px solid #f0f2f5;
        width: calc(100% - 80px);
        float: right;
        margin-top: -12px;
    }
    .occupation-detail-type {
        font-size: 14px;
        font-weight: 600;
        color: #332e2c;
        line-height: 20px;
        margin-top: 20px;
        position: relative;
    }
    .occupation-detail-chart1 {
        width: 400px;
        height: 250px;
    }
}
.occupation-detail-job-area {
    position: relative;
    top: -10px;
}
.occupation-detail-job-common-diff1 {
    width: 358px;
    .occupation-detail-line {
        width: calc(100% - 100px);
    }
    .no-data-box {
        position: relative;
        top: 45%;
    }
}
.occupation-detail-job-common-diff2 {
    width: 358px;
    .occupation-detail-line {
        width: calc(100% - 150px);
    }
    .no-data-box {
        position: relative;
        top: 45%;
    }
}
.occupation-detail-job-area-list {
    margin-top: 20px;
    .el-row {
        height: 42px;
        background: #f5f7fa;
        border-radius: 5px;
        padding: 8px 12px 8px 8px;
        box-sizing: border-box;
        align-items: center;
    }
    .el-row:not(:last-child) {
        margin-bottom: 6px;
    }
    .el-col-2 {
        width: 26px;
        height: 26px;
        background: #ff671a;
        border-radius: 6px;
        text-align: center;
        line-height: 26px;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
    }
    .area-top1 {
        background: #fe9f0a;
    }
    .area-top2 {
        background: #139b83;
    }
    .area-top3 {
        background: #3272ff;
    }
    .el-col-14 {
        font-size: 16px;
        font-weight: 600;
        color: #332e2c;
        padding-left: 12px;
    }
    .el-col-8 {
        font-size: 14px;
        font-weight: 400;
        text-align: right;
        color: #999390;
    }
}
.occupation-detail-subject {
    margin-top: 20px;
    >.el-row {
        // height: 76px;
        border-bottom: 1px solid #f0f2f5;
        padding: 12px 0;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #999390;
        line-height: 19px;
    }
    h4 {
        font-size: 16px;
        font-weight: 700;
        color: #332e2c;
        line-height: 21px;
        margin: 0;
        margin-bottom: 12px;
    }
    .el-col-8 {
        text-align: right;
    }
}
.no-data-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
}
.compare-view,.compare-view-diff {
		width: 136px;
		height: 50px;
		background: rgba(255,255,255,0.20)!important;
		border: 1px solid #ffffff;
		border-radius: 8px;
		color: #ffffff;
		font-size: 18px;
		text-align: center;
		padding: 0;
		background-color: #fff;
		float: right;
		margin-left: 16px;
		img {
			width: 12px;
			height: 12px;
		}
		.fav-img1 {
			width: 18px;
			height: 18px;
			position: relative;
			top: 2px;
		}
	}
	.compare-view-diff {
		color: $common-color!important;
		background: #ffffff!important;
		border: none!important;
	}
    ::v-deep {
		.el-rate__icon {
			font-size: 24px;
			position: relative;
			top: -2px;
			margin-right: 2px;
		}
		.el-rate__decimal {
			color: #ff6524!important;
			font-size: 24px;
		}
		.compare-view-diff span {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	} 
</style>